import { render, staticRenderFns } from "./DevicePage.vue?vue&type=template&id=6407ba1b&scoped=true"
import script from "./DevicePage.vue?vue&type=script&lang=js"
export * from "./DevicePage.vue?vue&type=script&lang=js"
import style0 from "./DevicePage.vue?vue&type=style&index=0&id=6407ba1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6407ba1b",
  null
  
)

export default component.exports